import React from "react";

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
}

// Ícone elegante para Apartamento - Prédio moderno
export const ApartmentIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <rect x="4" y="3" width="16" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M8 7h2v2H8V7zm0 4h2v2H8v-2zm0 4h2v2H8v-2z" fill="currentColor" />
    <path d="M14 7h2v2h-2V7zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2z" fill="currentColor" />
    <path d="M4 17h16v2H4v-2z" fill="currentColor" />
  </svg>
);

// Ícone elegante para Casa - Casa residencial
export const HouseIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <path d="M3 10.5L12 3l9 7.5V20a2 2 0 01-2 2H5a2 2 0 01-2-2v-9.5z" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M9 21V12h6v9" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="8" r="1" fill="currentColor" />
  </svg>
);

// Ícone elegante para Vivenda - Mansão elegante
export const VillaIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <path d="M4 20h16" stroke="currentColor" strokeWidth="1.5" />
    <path d="M4 20V10l4-3v13" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M16 20V10l4 3v7" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M8 7l4-4 4 4" stroke="currentColor" strokeWidth="1.5" />
    <path d="M9 13h6v3H9v-3z" fill="currentColor" />
    <path d="M12 3v4" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

// Ícone elegante para Quarto - Cama de hotel
export const RoomIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <path d="M4 17h16" stroke="currentColor" strokeWidth="1.5" />
    <rect x="2" y="12" width="8" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M10 12V9a2 2 0 012-2h6a2 2 0 012 2v8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="16" cy="7" r="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
  </svg>
);

// Ícone elegante para Hotel - Prédio de hotel
export const HotelBuildingIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <rect x="5" y="3" width="14" height="18" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M5 7h14" stroke="currentColor" strokeWidth="1.5" />
    <path d="M5 12h14" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12 7v11" stroke="currentColor" strokeWidth="1.5" />
    <path d="M8 16h2v2H8v-2zm6 0h2v2h-2v-2z" fill="currentColor" />
  </svg>
);

// Ícone elegante para Hospedaria - Sinal de pousada
export const GuesthouseIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <path d="M4 20h16" stroke="currentColor" strokeWidth="1.5" />
    <path d="M6 20V10l6-4 6 4v10" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="8" r="1.5" fill="currentColor" />
    <path d="M9 13h6v3H9v-3z" fill="currentColor" />
  </svg>
);

// Ícone elegante para Casa de Hóspedes - Casa com hóspedes
export const BedAndBreakfastIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <path d="M4 17h16" stroke="currentColor" strokeWidth="1.5" />
    <path d="M6 17V9l4-3 4 3v8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="14" cy="7" r="1.5" fill="currentColor" />
    <path d="M10 12h4v3h-4v-3z" fill="currentColor" />
  </svg>
);

// Ícone elegante para Condomínio - Complexo residencial
export const CondominiumIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <rect x="2" y="8" width="7" height="13" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <rect x="15" y="8" width="7" height="13" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <rect x="8" y="5" width="8" height="16" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M2 21h20" stroke="currentColor" strokeWidth="1.5" />
    <path d="M9 8v2h6V8l-3-2-3 2z" fill="currentColor" />
  </svg>
);

// Ícone elegante para Resort - Palmeiras e mar
export const ResortIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <path d="M2 17h20" stroke="currentColor" strokeWidth="1.5" />
    <path d="M4 17V12a2 2 0 012-2h2a2 2 0 012 2v5" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M6 10c0-3 2-5 2-5s2 2 2 5" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M14 17V10c0-2.5 2-4 2-4s2 1.5 2 4v7" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="16" cy="6" r="1.5" fill="currentColor" />
  </svg>
);

// Ícone elegante para Casa de Férias - Casa na praia
export const VacationHomeIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <path d="M3 10.5L12 4l9 6.5V20a2 2 0 01-2 2H5a2 2 0 01-2-2v-9.5z" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M9 21V14h6v7" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M2 17c2-1 4-1 6 0s4 1 6 0 4-1 6 0 2 1 2 0" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

// Ícone elegante para Barco - Iate elegante
export const YachtIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <path d="M4 16c1-2 3-3 5-3h6c2 0 4 1 5 3" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12 13V6" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12 6l3-2v4l-3 2z" fill="currentColor" />
    <path d="M4 16l2 4h12l2-4" stroke="currentColor" strokeWidth="1.5" fill="none" />
  </svg>
);

// Ícone elegante para Casa de Campo - Cabana rústica
export const CountryHouseIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <path d="M4 20h16" stroke="currentColor" strokeWidth="1.5" />
    <path d="M5 20V11l6-5 6 5v9" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M2 11l9-7 2 1.5 2-1.5 9 7" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M10 20v-5h4v5" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="17" cy="14" r="1" fill="currentColor" />
  </svg>
);

// Ícone elegante para Contentor - Container moderno
export const ContainerIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <rect x="3" y="6" width="18" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7 6v12" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12 6v12" stroke="currentColor" strokeWidth="1.5" />
    <path d="M17 6v12" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

// Ícone elegante para Espaço Único - Estrela brilhante
export const UniqueSpaceIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <path d="M12 2l2.5 6.5L21 9l-5 4 2 6-6-3.5-6 3.5 2-6-5-4 6.5-.5L12 2z" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="12" r="2" fill="currentColor" />
  </svg>
);

// Ícone Todos - Grid de espaços
export const AllSpacesIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
  </svg>
);

// Ícone elegante para Calendário
export const ElegantCalendarIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style}>
    <rect x="3" y="6" width="18" height="15" rx="3" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7 4v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M17 4v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 4v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M3 11h18" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7 15h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="15" cy="15" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);
